// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_home_home_module_ts":"9f67b34bd6ee3b48","src_app_sessions_sessions_module_ts":"39c6f77d13ea4dc5"}[chunkId] + ".js";
};